import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonBackComponent } from './button-back.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule],
    declarations: [ButtonBackComponent],
    exports: [ButtonBackComponent],
})
export class ButtonBackModule {}
